import { useT } from "react-polyglot-hooks"
import * as PropTypes from "prop-types"
import capitalize from "lodash/capitalize"
import useFilteredOptions from "hooks/useFilteredOptions"
import Selector from "../Selector"
import Typography from "../../../styled/Typography"

export default function TransmissionSelector({ field, value, show, handleChange, label, col }) {
  const t = useT()

  const options = useFilteredOptions(field, () => [
    { value: "manual", label: capitalize(t("car.transmission.manual")) },
    { value: "automatic", label: capitalize(t("car.transmission.automatic")) }
  ])

  if (!show) return null

  return (
    <>
      {label && (
        <Typography el="label" className="mb-2">
          {label}
        </Typography>
      )}
      <Selector field={field} initialValue={value} options={options} handleChange={handleChange} col={col} />
    </>
  )
}

TransmissionSelector.defaultProps = {
  show: true,
  value: "",
  label: "",
  field: "transmission",
  col: null
}

TransmissionSelector.propTypes = {
  show: PropTypes.bool,
  label: PropTypes.string,
  field: PropTypes.string,
  value: PropTypes.string,
  handleChange: PropTypes.func.isRequired,
  col: PropTypes.shape({
    xs: PropTypes.number,
    sm: PropTypes.number
  })
}
